import React from 'react';

import Leaderboard from "./components/Leaderboard/Leaderboard";

import './App.scss';


function App() {
  return (
    <div className="App">
      <Leaderboard />
    </div>
  );
}

export default App;
